import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "reseller", "account", "accountSelect", "brands", "coupon", "distributor" ]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const show = this.resellerTarget.checked || this.distributorTarget?.checked

    this.accountTarget.style.display = show ? "" : "none"
    this.brandsTarget.style.display = show ? "" : "none"
    this.couponTarget.style.display = show ? "" : "none"

    if (show) {
      let accountId = null
      const accountHidden = this.accountTarget.querySelector('input[type="hidden"][name="ecommerce_customer[account_id]"]')
      const accountSelect = this.accountTarget.querySelector('select[name="ecommerce_customer[account_id]"]')
      if (accountHidden && accountHidden.value) {
        accountId = accountHidden.value
      } else if (accountSelect && accountSelect.value) {
        accountId = accountSelect.value
      }

      if (accountId) {
        fetch(`/accounts/${accountId}/brands_and_categories`)
          .then(response => {
            if (!response.ok) throw new Error("Network response was not ok")
            return response.json()
          })
          .then(data => {
            this.updateBrands(data.brands)
          })
          .catch(error => {
            console.error("Error fetching brands and categories:", error)
          })
      }
    }
  }

  accountChanged(event) {
    const accountId = event.target.value
    if (!accountId) return

    fetch(`/accounts/${accountId}/brands_and_categories`)
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok")
        return response.json()
      })
      .then(data => {
        this.updateBrands(data.brands)
      })
      .catch(error => {
        console.error("Error fetching brands and categories:", error)
      })
  }

  updateBrands(brands) {
    const brandsSelect = document.getElementById("brands-select")
    if (brandsSelect) {
      brandsSelect.innerHTML = this.buildOptions("customer_reseller_featured_brands", brands)
    }
  }

  buildOptions(fieldName, options) {
    return `<select name="${fieldName}[]" multiple="multiple" class="form-control">
      ${options.map(opt => `<option value="${opt.id}">${opt.name}</option>`).join("")}
    </select>`
  }
}
